var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isBaiduMap || _vm.isBaiduMapAuto ? _c('div', {
    staticClass: "title",
    class: {
      'trans-bg': _vm.transBg
    },
    on: {
      "dblclick": function ($event) {
        $event.stopPropagation();
        return _vm.handleContent.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "title-top"
  }), _c('div', {
    staticClass: "title-box"
  }, [!_vm.hiddenBackBtn ? _c('div', {
    staticClass: "title-left",
    style: _vm.titleLeftAll
  }, [!_vm.newBackBtn ? _c('div', {
    staticClass: "title-left-box",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleLeft.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "title-left-box-back"
  }), _vm.leftText ? _c('span', {
    staticClass: "title-left-box-text"
  }, [_vm._v(_vm._s(_vm.leftText))]) : _vm._e()]) : _vm._e(), _vm._t("left-content")], 2) : _vm._e(), _c('div', {
    staticClass: "title-content",
    class: {
      'is-ios-title': _vm.isIPhone
    },
    style: _vm.titleContentAll
  }, [_vm.content ? _c('div', [_vm._v(_vm._s(_vm.content))]) : _vm._e(), _vm._t("content")], 2), _c('div', {
    staticClass: "title-right",
    style: _vm.titleRightAll
  }, [_vm.rightText ? _c('div', {
    staticClass: "title-right-text"
  }, [_vm._v(_vm._s(_vm.rightText))]) : _vm._e(), _vm._t("right-content")], 2)]), _c('div', {
    staticClass: "title-bottom"
  }, [_vm._t("title-bottom")], 2)]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };